import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useCars() {
  const { mode } = useAppSelector((state) => state.fleet);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: ["cars", mode],
    queryFn: () => {
      return Api.get(`car?${nameQuery()}&${statusQuery()}`, "https://admin-api.behamrah.kashantejarat.ir/api/v1/").then(
        (res) => res.data.Data.data
      );
    },
    enabled: mode === "cars",
  });

  return { data, isLoading, refetch, isFetching };
}
